import { ConfigProvider, DatePicker, Input, Select, Space } from 'antd';
import dayjs from 'dayjs';
import React, { memo, useRef } from 'react';

import viVN from 'antd/locale/vi_VN';
import { isNumber } from 'lodash';
import { IConditionSV2, IVConditionFilterV2 } from '../../../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { ISelectOption } from '../../../../../../../../api/selectOptions/selectOptionsApi';
import { handleDateChangeDayJsGroup, handleDateChangeDayJsGroupDayMonth } from '../../../../../../../../until';
import { OptionSelect_V2 } from '../../../../../../../SystemConfiguration/AccountsManagement/Components/TreeSelectCustom';
import { TreeSelectCustom_V2 } from '../../../../../../../SystemConfiguration/AccountsManagement/Components/TreeSelectCustom_V2';
import '../../../../../style.scss';

type FromKey = "valueDayFrom" | "valueMonthFrom" | "valueYearFrom";
type ToKey = "valueDayTo" | "valueMonthTo" | "valueYearTo";

export enum DROPDOWN_TYPE {
    SELECT = 0,
    TREE_SELECT = 1
}

const FROM_TO_KEY_MAP: Record<FromKey, ToKey> = {
    valueDayFrom: "valueDayTo",
    valueMonthFrom: "valueMonthTo",
    valueYearFrom: "valueYearTo",
};

function getMinMax(type: "valueDayFrom" | "valueMonthFrom" | "valueYearFrom") {
    const CURRENT_YEAR = new Date().getFullYear();
    switch (type) {
        case "valueDayFrom":
            return {
                min: 1,
                max: 31,
            };

        case "valueMonthFrom":
            return {
                min: 1,
                max: 12,
            };

        case "valueYearFrom":
            return {
                min: 1926,
                max: CURRENT_YEAR + 1,
            };

        default:
            return {
                min: 1,
                max: 99,
            };
    }
}

const clamp = (value: number, min: number, max: number) => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return null;
    }
    return Math.min(max, Math.max(min, value));
};

const parseNumericOrNull = (raw: string): number | null => {
    if (raw === "") return null;
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
};

interface Props {
    disabled: boolean
    index: number

    //mơi
    itemCondition: IConditionSV2
    setInfoOperatorTmp: React.Dispatch<React.SetStateAction<IVConditionFilterV2>>
}

// Hàm format số
const formatNumber = (num: number) => {
    if (!num && num !== 0) return '';
    return new Intl.NumberFormat('vi-VN').format(num);
};

// Hàm parse số
const parseNumber = (str: string) => {
    if (!str) return null;
    // Loại bỏ tất cả ký tự không phải số
    const numbersOnly = str.replace(/[^\d]/g, '');
    return numbersOnly ? parseInt(numbersOnly, 10) : null;
};


const { RangePicker } = DatePicker;



const RenderInputType: React.FC<Props> = ({
    disabled,
    index,

    //moi
    itemCondition,
    setInfoOperatorTmp
}) => {
    const inputValueRef = useRef<
        Record<number, Partial<Record<FromKey, number | null>>>
    >({});

    const { value, CustomerField } = itemCondition
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
    switch (CustomerField?.inputType) {
        case "string": {
            const hasValueS = value != null;
            const commonProps = {
                className: "w-full bg-FCFCFD  ",
                disabled: disabled || !hasValueS,
            };

            return (
                CustomerField.fieldCode === "cus_tel" ? (
                    <Input
                        {...commonProps}
                        type="text"           // tránh mất số 0 đầu
                        inputMode="numeric"   // gợi ý bàn phím số trên mobile
                        pattern="\d*"         // hint validation
                        maxLength={12}
                        value={value?.valueText ?? ""}
                        onKeyDown={(e) => {
                            const allowed =
                                ["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key) ||
                                e.ctrlKey || e.metaKey;
                            const isDigit = /^[0-9]$/.test(e.key);
                            if (!allowed && !isDigit) e.preventDefault();
                        }}
                        onChange={(e) => {
                            // Lọc chỉ giữ số và giới hạn 12 ký tự
                            const next = (e.target.value || "").replace(/\D/g, "").slice(0, 12);
                            const checkAdd = next.length > 0;

                            setInfoOperatorTmp(prev => ({
                                ...prev,
                                conditions: prev.conditions.map((condition, i) =>
                                    i === index
                                        ? { ...condition, isAdd: checkAdd, value: { valueText: next } }
                                        : condition
                                )
                            }));
                        }}
                    />
                ) : (
                    <Input
                        {...commonProps}
                        value={value?.valueText ?? ""}
                        onChange={(e) => {
                            const next = e.target.value ?? "";
                            const checkAdd = next !== "";

                            setInfoOperatorTmp(prev => ({
                                ...prev,
                                conditions: prev.conditions.map((condition, i) =>
                                    i === index
                                        ? { ...condition, isAdd: checkAdd, value: { valueText: next } }
                                        : condition
                                )
                            }));
                        }}
                    />
                )
            );
        }

        case "dropdown":
            const hasValueDD = itemCondition.optionsData != null || itemCondition.optionsData != undefined;
            return (
                <div className="w-full  h-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center justify-between overflow-hidden">
                    <div className="h-full w-full custom-page-css flex items-center">
                        {
                            CustomerField.type == DROPDOWN_TYPE.SELECT ?

                                <Select
                                    showSearch={true}
                                    autoClearSearchValue={false}
                                    allowClear
                                    mode="multiple"
                                    // className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select  line-none line-none-item inline-none size-selector"
                                    // className="w-full custom-page-css flex items-center text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select h-full line-none line-none-item inline-none size-selector"
                                    className='  w-full custom-scroll-multi-select'
                                    variant="borderless"
                                    // suffixIcon={null}
                                    disabled={disabled || !hasValueDD}
                                    options={itemCondition.optionsData}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={value?.options?.map(opt => opt.value) ?? undefined}
                                    onChange={(values: (string | number)[], option?: ISelectOption | ISelectOption[]) => {
                                        const selectedOptions = Array.isArray(option) ? option : option ? [option] : [];
                                        const checkAdd = selectedOptions.length > 0;

                                        setInfoOperatorTmp(prev => ({
                                            ...prev,
                                            conditions: prev.conditions.map((condition, i) =>
                                                i === index
                                                    ? {
                                                        ...condition,
                                                        isAdd: checkAdd,
                                                        value: {
                                                            options: selectedOptions,
                                                        },
                                                    }
                                                    : condition
                                            ),
                                        }));
                                    }}
                                />
                                : (
                                    <div className="relative w-full div-children-full h-full overflow-hidden">


                                        <TreeSelectCustom_V2
                                            className="h-full w-full custom-select-tree"
                                            data={itemCondition.optionsData as OptionSelect_V2[] ?? []}
                                            value={value?.options?.map(o => o.value) ?? []}                              // ví dụ: [101, 205]
                                            cascadeDisable={true}
                                            disableMode="disabled"
                                            placeholder=''
                                            onChange={(ids: number[]) => {
                                                const optionsDataTmp = (itemCondition.optionsData as OptionSelect_V2[]) ?? [];

                                                // flatten tree
                                                const flatten = (data: OptionSelect_V2[]): OptionSelect_V2[] => {
                                                    return data.flatMap(item => [
                                                        item,
                                                        ...(item.children ? flatten(item.children) : [])
                                                    ]);
                                                };

                                                const flatData = flatten(optionsDataTmp);

                                                // filter theo ids
                                                const result = flatData
                                                    .filter(item => ids.includes(item.value))
                                                    .map(item => ({
                                                        value: item.value,
                                                        label: item.label
                                                    }));

                                                const checkAdd = result.length > 0;

                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((condition, i) =>
                                                        i === index
                                                            ? {
                                                                ...condition,
                                                                isAdd: checkAdd,
                                                                value: { options: result },
                                                            }
                                                            : condition
                                                    ),
                                                }));
                                            }}
                                        />

                                        {(value?.options?.length ?? 0) > 0 && (
                                            <p className="bg-F0F5FF border-ADC6FF rounded-2 text-2F54EB text-sm px-2 d-flex align-center gap-3-px h-auto font-regular justify-between absolute custom-css-count-select">
                                                {value?.options?.length} đơn vị được chọn
                                            </p>
                                        )}
                                    </div>
                                )


                        }
                    </div>
                </div>
            );
        case "date":
            let keyRanger = '';
            if (value) {
                keyRanger = Object?.keys(value as any)[0];
            }

            switch (keyRanger) {
                case "valueDayFrom":
                case "valueMonthFrom":
                case "valueYearFrom":
                    {

                        const hasValueN = value != null;
                        const { min, max } = getMinMax(keyRanger)
                        const fromKey = keyRanger as FromKey;

                        const valueFrom = value?.valueDayFrom ?? value?.valueMonthFrom ?? value?.valueYearFrom
                        const valueTo = value?.valueDayTo ?? value?.valueMonthTo ?? value?.valueYearTo
                        return (
                            <div className='custom-page-css w-full flex flex-col items-end gap-2'>
                                <div className='custom-page-css w-full flex items-center gap-2'>
                                    <div className="custom-page-css flex-1">
                                        <Input
                                            className="custom-input-css custom-page-css border h-full"
                                            style={{
                                                maxHeight: 36
                                            }}
                                            type="number"
                                            inputMode="numeric"
                                            disabled={disabled || !hasValueN}
                                            placeholder="Số thứ 1"
                                            value={valueFrom ?? undefined}
                                            onChange={(e) => {
                                                const raw = e.target.value;
                                                const n = parseNumericOrNull(raw);

                                                // đảm bảo object tồn tại
                                                if (!inputValueRef.current[index]) {
                                                    inputValueRef.current[index] = {};
                                                }

                                                // lưu giá trị đang gõ
                                                inputValueRef.current[index][fromKey as FromKey] = n;

                                                // update state (cho phép gõ dở)
                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((c, i) =>
                                                        i === index ?
                                                            {
                                                                ...c,
                                                                value: {
                                                                    ...c.value,
                                                                    [fromKey as FromKey]: n,
                                                                },
                                                            } :
                                                            c
                                                    ),
                                                }));

                                                if (n !== null && (n < min || n > max)) {
                                                    setErrorMessage(`Giá trị phải trong khoảng ${min} - ${max}`);
                                                } else {
                                                    setErrorMessage(null);
                                                }
                                            }}

                                            onBlur={() => {
                                                const current = inputValueRef.current[index]?.[fromKey as FromKey] ?? null;

                                                const other = valueTo ?? null;

                                                if (current === null) {
                                                    setInfoOperatorTmp(prev => ({
                                                        ...prev,
                                                        conditions: prev.conditions.map((c, i) =>
                                                            i === index ?
                                                                {
                                                                    ...c,
                                                                    isAdd: false
                                                                } :
                                                                c
                                                        ),
                                                    }));
                                                    return;
                                                }

                                                const clamped = Math.min(max, Math.max(min, current));
                                                const checkAdd = other !== null && other >= clamped;

                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((c, i) =>
                                                        i === index ?
                                                            {
                                                                ...c,
                                                                isAdd: checkAdd,
                                                                value: {
                                                                    ...c.value,
                                                                    [keyRanger as FromKey]: clamped,
                                                                },
                                                            } :
                                                            c
                                                    ),
                                                }));
                                            }}
                                        />
                                    </div>

                                    <div className="custom-page-css flex-1">
                                        <Input
                                            className="custom-input-css custom-page-css border h-full"
                                            style={{
                                                maxHeight: 36
                                            }}
                                            type="number"
                                            inputMode="numeric"
                                            disabled={disabled || !isNumber(valueFrom)}
                                            placeholder="Số thứ 2"
                                            value={valueTo ?? undefined}
                                            onChange={(e) => {
                                                const raw = e.target.value;
                                                const n = parseNumericOrNull(raw); // number | null

                                                // đảm bảo ref tồn tại
                                                if (!inputValueRef.current[index]) {
                                                    inputValueRef.current[index] = {};
                                                }

                                                const toKey = FROM_TO_KEY_MAP[fromKey];

                                                // lưu giá trị đang gõ của số thứ 2
                                                inputValueRef.current[index][fromKey] = n;

                                                // update state (cho phép gõ dở)
                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((c, i) =>
                                                        i === index
                                                            ? {
                                                                ...c,
                                                                value: {
                                                                    ...c.value,
                                                                    [toKey]: n,
                                                                },
                                                            }
                                                            : c
                                                    ),
                                                }));

                                                // chỉ báo lỗi, KHÔNG ép
                                                if (valueFrom !== null && valueFrom !== undefined && n !== null && n < valueFrom) {
                                                    setErrorMessage("Số thứ 2 phải lớn hơn hoặc bằng số thứ 1");
                                                } else if (n !== null && (n < min || n > max)) {
                                                    setErrorMessage(`Giá trị phải trong khoảng ${min} - ${max}`);
                                                } else {
                                                    setErrorMessage(null);
                                                }
                                            }}

                                            onBlur={() => {
                                                const toKey = FROM_TO_KEY_MAP[fromKey];

                                                const current =
                                                    inputValueRef.current[index]?.[fromKey] ?? null;

                                                const from = valueFrom ?? null;

                                                if (current === null || from === null) {
                                                    // chưa đủ dữ liệu → reset isAdd
                                                    setInfoOperatorTmp(prev => ({
                                                        ...prev,
                                                        conditions: prev.conditions.map((c, i) =>
                                                            i === index ? { ...c, isAdd: false } : c
                                                        ),
                                                    }));
                                                    return;
                                                }

                                                // clamp tại đây
                                                const clamped = Math.min(max, Math.max(min, current));

                                                const checkAdd = clamped >= from;

                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((c, i) =>
                                                        i === index
                                                            ? {
                                                                ...c,
                                                                isAdd: checkAdd,
                                                                value: {
                                                                    ...c.value,
                                                                    [toKey]: clamped,
                                                                },
                                                            }
                                                            : c
                                                    ),
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                {errorMessage && (
                                    <div className=" custom-page-css text-F5222D text-xs mt-1 ">
                                        {errorMessage}
                                    </div>
                                )}
                            </div>
                        )
                    }
                case "valueDayMonthFrom":
                    {
                        const parseDateGroupV2 = (dateStr?: string | null) => {
                            if (!dateStr) return null;
                            const d1 = dayjs(dateStr, 'DD/MM', true);
                            if (d1.isValid()) return d1;
                            return d1 ? d1 : null;
                        };

                        const valueDayMonthFrom = parseDateGroupV2(value?.valueDayMonthFrom);
                        const valueDayMonthTo = parseDateGroupV2(value?.valueDayMonthTo);
                        return (
                            <ConfigProvider locale={viVN}>
                                <Space direction="vertical" className="w-full">
                                    <RangePicker
                                        allowClear={false}
                                        className="custom-input-date w-full"
                                        // open={true}
                                        placeholder={["Bắt đầu", "Kết thúc"]}
                                        format='DD/MM'
                                        disabled={disabled}
                                        value={[valueDayMonthFrom, valueDayMonthTo]}
                                        onChange={(date) => {

                                            setInfoOperatorTmp(prev => ({
                                                ...prev,
                                                conditions: prev.conditions.map((condition, i) =>
                                                    i === index // targetIndex là index của condition cần update
                                                        ? {
                                                            ...condition,
                                                            isAdd: true,
                                                            value: {
                                                                valueDayMonthFrom: handleDateChangeDayJsGroupDayMonth(date ? date[0] : null),
                                                                valueDayMonthTo: handleDateChangeDayJsGroupDayMonth(date ? date[1] : null), // gán valueText mới
                                                            }
                                                        }
                                                        : condition
                                                )
                                            }));
                                        }}
                                        renderExtraFooter={undefined}
                                    />
                                </Space>
                            </ConfigProvider >
                        )
                    }
                default:
                    const hasValue = value != null;
                    const isOne = Object.hasOwn(value ?? {}, 'valueDate');
                    // parse đúng field, đảm bảo dùng dayjs object
                    const parseDateGroup = (dateStr?: string | null) => {
                        if (!dateStr) return null;
                        const d1 = dayjs(dateStr, 'DD/MM/YYYY', true);
                        if (d1.isValid()) return d1;
                        const d2 = dayjs(dateStr, 'YYYY/MM/DD', true);
                        return d2.isValid() ? d2 : null;
                    };
                    const valueDate = parseDateGroup(value?.valueDate);
                    const valueDateStart = parseDateGroup(value?.valueDateStart);
                    const valueDateEnd = parseDateGroup(value?.valueDateEnd);

                    return (
                        <ConfigProvider locale={viVN}>
                            {
                                (isOne || !hasValue) ? (
                                    // 1 ngày *
                                    <Space direction="vertical" className="w-full">
                                        <DatePicker
                                            allowClear={false}
                                            className='w-full custom-input-date'
                                            format='DD/MM/YYYY'
                                            disabled={disabled || !hasValue}
                                            value={valueDate}
                                            onChange={(e) => {
                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((condition, i) =>
                                                        i === index // targetIndex là index của condition cần update
                                                            ? {
                                                                ...condition,
                                                                isAdd: true,
                                                                value: {
                                                                    valueDate: handleDateChangeDayJsGroup(e) // gán valueText mới
                                                                }
                                                            }
                                                            : condition
                                                    )
                                                }));
                                            }}
                                        />
                                    </Space>
                                ) : (
                                    // 2 ngày
                                    <RangePicker
                                        allowClear={false}
                                        className="custom-input-date w-full"
                                        // open={true}
                                        placeholder={["Bắt đầu", "Kết thúc"]}
                                        format="DD/MM/YYYY"
                                        disabled={disabled}
                                        value={[valueDateStart, valueDateEnd]}
                                        onChange={(date) => {

                                            setInfoOperatorTmp(prev => ({
                                                ...prev,
                                                conditions: prev.conditions.map((condition, i) =>
                                                    i === index // targetIndex là index của condition cần update
                                                        ? {
                                                            ...condition,
                                                            isAdd: true,
                                                            value: {
                                                                valueDateStart: handleDateChangeDayJsGroup(date ? date[0] : null),
                                                                valueDateEnd: handleDateChangeDayJsGroup(date ? date[1] : null), // gán valueText mới
                                                            }
                                                        }
                                                        : condition
                                                )
                                            }));
                                        }}
                                        renderExtraFooter={undefined}
                                    />
                                )
                            }
                        </ConfigProvider >
                    );
            }
        case "number":
            const hasValueN = value != null;
            // const isOneN = Object.hasOwn(value ?? {}, 'valueNumber');
            const isRangeCondition =
                itemCondition.condition?.label?.toLowerCase().includes('khoảng')
            return (
                <>
                    {
                        (!isRangeCondition || !hasValueN) ? (
                            <Input
                                className="custom-input-css custom-page-css border h-full"
                                style={{
                                    maxHeight: 36
                                }}
                                disabled={disabled || !hasValueN}
                                type='text'
                                maxLength={18}
                                value={
                                    value?.valueNumber !== undefined &&
                                        value?.valueNumber !== null
                                        ? formatNumber(value.valueNumber)
                                        : undefined
                                }
                                onChange={(e) => {
                                    const raw = parseNumber(e.target.value);
                                    const checkAdd = (raw !== undefined && raw !== null)
                                    setInfoOperatorTmp(prev => ({
                                        ...prev,
                                        conditions: prev.conditions.map((condition, i) =>
                                            i === index // targetIndex là index của condition cần update
                                                ? {
                                                    ...condition,
                                                    isAdd: checkAdd,
                                                    value: {
                                                        valueNumber: raw ? Number(raw) : null,
                                                    }
                                                }
                                                : condition
                                        )
                                    }));
                                }}
                            />
                        ) : (
                            <div className='custom-page-css w-full flex flex-col items-end gap-2'>
                                <div className='custom-page-css w-full flex items-center gap-2'>
                                    <div className="custom-page-css flex-1">
                                        <Input
                                            className="custom-input-css custom-page-css border h-full"
                                            style={{
                                                maxHeight: 36
                                            }}
                                            type="text" // dùng text để cho phép hiển thị dấu chấm
                                            maxLength={18}
                                            disabled={disabled || !hasValueN}
                                            placeholder="Số thứ 1"
                                            value={value?.valueNumberMin !== undefined && value?.valueNumberMin !== null
                                                ? formatNumber(value.valueNumberMin)
                                                : ""}
                                            onChange={(e) => {
                                                const rawValue = e.target.value;
                                                const input1Value = parseNumber(rawValue);
                                                const input2Value = value?.valueNumberMax ?? null;
                                                // Validation
                                                if (input2Value !== null && input1Value !== null && input2Value <= input1Value || (input1Value !== null && input2Value === null)) {
                                                    setErrorMessage("Số thứ 2 phải lớn hơn số thứ 1");
                                                } else {
                                                    setErrorMessage(null);
                                                }
                                                const checkAdd = Boolean(
                                                    input1Value !== null &&
                                                    input2Value !== null &&
                                                    input2Value > input1Value
                                                );
                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((condition, i) =>
                                                        i === index
                                                            ? {
                                                                ...condition,
                                                                isAdd: checkAdd,
                                                                value: {
                                                                    valueNumberMin: input1Value,
                                                                    valueNumberMax: input2Value,
                                                                }
                                                            }
                                                            : condition
                                                    )
                                                }));
                                            }}
                                        />
                                    </div>

                                    <div className="custom-page-css flex-1">
                                        <Input
                                            className="custom-input-css custom-page-css border h-full"
                                            style={{
                                                maxHeight: 36
                                            }}
                                            type="text"
                                            maxLength={18}
                                            disabled={disabled || !isNumber(value?.valueNumberMin)}
                                            placeholder="Số thứ 2"
                                            value={
                                                value?.valueNumberMax !== undefined &&
                                                    value?.valueNumberMax !== null ?
                                                    formatNumber(value.valueNumberMax) :
                                                    undefined
                                            }
                                            onChange={(e) => {

                                                const raw = parseNumber(e.target.value);
                                                const input1Value = value?.valueNumberMin !== undefined && value?.valueNumberMin !== null ? value.valueNumberMin : null;
                                                const input2Value = raw ? Number(raw) : null;
                                                // Validation
                                                if (input1Value !== null && input2Value !== null && input2Value <= input1Value || (input1Value !== null && input2Value === null)) {
                                                    setErrorMessage("Số thứ 2 phải lớn hơn số thứ 1");
                                                } else {
                                                    setErrorMessage(null);
                                                }

                                                const checkAdd = Boolean(
                                                    input1Value !== null &&
                                                    input2Value !== null &&
                                                    input2Value > input1Value
                                                );

                                                setInfoOperatorTmp(prev => ({
                                                    ...prev,
                                                    conditions: prev.conditions.map((condition, i) =>
                                                        i === index
                                                            ? {
                                                                ...condition,
                                                                isAdd: checkAdd,
                                                                value: {
                                                                    valueNumberMin: input1Value,
                                                                    valueNumberMax: input2Value,
                                                                }
                                                            }
                                                            : condition
                                                    )
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                {errorMessage && (
                                    <div className=" custom-page-css text-F5222D text-xs mt-1 ">
                                        {errorMessage}
                                    </div>
                                )}
                            </div>
                        )
                    }
                </>

            );
        default:
            return (
                <Input
                    className="custom-input-css custom-page-css border h-full"
                    style={{
                        maxHeight: 36
                    }}
                    disabled={disabled}
                />
            );
    }
}
export default memo(RenderInputType) 